/*
 * Copyright (c) 2023 SmartWifi - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential. No warranty, explicit or implicit provided. In
 * no event will the author be liable for any claim or damages.
 */

const GridContainer = ({
  width = 200,
  gap = 0,
  className,
  children,
  style = {},
}) => (
  <div
    className={className}
    style={{
      display: "grid",
      gridTemplateColumns: `repeat(auto-fit, minmax(${width}px, 1fr))`,
      gridGap: `${gap}px`,
      ...style,
    }}
  >
    {children}
  </div>
);

export default GridContainer;
